import React, { useEffect } from "react";
import ClientSummaryTable from "../../Components/Clients/ClientSummaryTable";
import Grid from "@mui/material/Grid2";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const Clients = () => {
	useEffect(() => {
		document.title = "Clients - CPC";
	}, []);
	return (
		<>
			<Grid container
				  spacing={3}
				  justifyContent='space-between'
			>
				<Grid size={{ xs: 5, sm: 8 }} >
					<Typography variant="h2">Clients</Typography>
				</Grid>
				<Grid size={{ xs: 7, sm: 4 }} sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: {xs: 'right', sm: 'right'}}}
				>
					<Link to="/clients/new">
						<Button variant="contained" color="primary">Create New Client</Button>
					</Link>
				</Grid>
				<Grid size={{xs: 12}}>
					<ClientSummaryTable initialRowsLoaded={10}/>
				</Grid>
			</Grid>
		</>
	);
};

export default Clients;
